import { Link } from "react-router-dom";
import WeatherGlass from "./WeatherGlass";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen h-[100vh] [height:100svh] [min-height:100svh] overflow-hidden bg-background-50">
      <img
        src="https://static.readdy.ai/image/ef1aae41220ad17a1705abffff22a58b/e928bc96acf9cbf4483b18f3eab929ae.webp"
        alt="Outdoor hero campaign"
        className="absolute inset-0 w-full h-full object-cover object-[70%_center] md:object-[65%_center]"
      />
      <WeatherGlass
        backgroundUrl="https://static.readdy.ai/image/ef1aae41220ad17a1705abffff22a58b/e928bc96acf9cbf4483b18f3eab929ae.webp"
        className="absolute inset-0 w-full h-full pointer-events-none"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/10 to-transparent pointer-events-none"></div>

      {/* Meta strip top */}
      <div className="absolute top-24 md:top-28 left-0 right-0 z-10">
        <div className="w-full px-5 md:px-10 flex items-center justify-between text-[10px] tracking-[0.24em] uppercase text-foreground-100/70">
          <span>AW26 — Field Collection</span>
          <span className="hidden md:inline">N 46.5° / E 8.2°</span>
        </div>
      </div>

      {/* Bottom composition */}
      <div className="relative z-10 h-full w-full px-5 md:px-10 lg:pr-16 pb-12 md:pb-20 flex flex-col justify-end">
        <div className="grid grid-cols-1 md:grid-cols-12 items-end gap-6 md:gap-8">
          <div className="md:col-span-7">
            <h1 className="text-[36px] md:text-[64px] leading-[1.08] md:leading-[1.0] tracking-[-0.02em] text-foreground-50 font-light">
              Built for the <span className="font-serif italic font-normal">quiet</span> distance.
            </h1>
          </div>

          <div className="md:col-span-4 md:col-start-9 flex flex-col items-start md:items-end text-left md:text-right">
            <p className="text-[15px] md:text-[14px] text-foreground-100/95 mb-5 md:mb-6 max-w-[320px] leading-relaxed">
              Field-tested outerwear, footwear and packs — engineered for the long trail ahead.
            </p>
            <Link
              to="/shop/outerwear"
              className="inline-flex items-center gap-3 px-6 md:px-7 min-h-[48px] bg-primary-500 hover:bg-primary-600 text-foreground-50 text-[14px] md:text-[13px] rounded-full transition cursor-pointer whitespace-nowrap"
            >
              Shop Outerwear
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 left-6 md:left-10 z-10 hidden md:flex items-center gap-3 text-foreground-100/60 text-[10px] tracking-[0.24em] uppercase">
        <span className="w-8 h-px bg-foreground-100/40"></span>
        <span>Scroll</span>
      </div>
    </section>
  );
}